import gql from 'graphql-tag'
import {
    AddOrganizationAdmin,
    AddOrganizationAdminMutation as AddAdminMutation,
    AddOrganizationAdminMutationVariables as AddAdminMutationVars,
    CreateImage,
    CreateImageMutation,
    CreateImageMutationVariables as CreateImageMutationVars,
    DeleteImageMutation,
    DeleteImageMutationVariables as DeleteImageMutationVars,
    RemoveEventAdminMutation,
    RemoveEventAdminMutationVariables as RemoveEventAdminMutationVars,
    RemoveOrganizationAdmin,
    RemoveOrganizationAdminMutation as RemoveAdminMutation,
    RemoveOrganizationAdminMutationVariables as RemoveAdminMutationVars,
    UpdateOrganization,
    UpdateOrganizationMutation as UpdateMutation,
    UpdateOrganizationMutationVariables as UpdateMutationVars,
} from 'generated/graphql'
import graphql from 'utils/graphql'

const updateOrganizationMutation = gql`
    mutation updateOrganization($id: ID!, $data: UpdateOrganization!) {
        updateOrganization(id: $id, data: $data) {
            id
        }
    }
`
export const updateOrganization = (id, data: UpdateOrganization) => {
    const query = graphql.createQuery<UpdateMutation, UpdateMutationVars>(updateOrganizationMutation)
    return query({ id, data })
}

const addAdminMutation = gql`
    mutation addOrganizationAdmin($data: AddOrganizationAdmin!) {
        addOrganizationAdmin(data: $data) {
            about
            company
            email
            firstName
            hasLoggedOn
            id
            jobtitle
            lastName
            mugshot
        }
    }
`
export const addOrganizationAdmin = (data: AddOrganizationAdmin) => {
    const query = graphql.createQuery<AddAdminMutation, AddAdminMutationVars>(addAdminMutation)
    return query({ data })
}

const removeAdminMutation = gql`
    mutation removeOrganizationAdmin($data: RemoveOrganizationAdmin!) {
        removeOrganizationAdmin(data: $data) {
            id
        }
    }
`
export const removeOrganizationAdmin = (data: RemoveOrganizationAdmin) => {
    const query = graphql.createQuery<RemoveAdminMutation, RemoveAdminMutationVars>(removeAdminMutation)
    return query({ data })
}

const removeEventAdminMutation = gql`
    mutation removeEventAdmin($data: RemoveAdmin!) {
        removeAdmin(data: $data)
    }
`
export const removeEventAdmin = (eventSlug, userId) => {
    // eslint-disable-next-line max-len
    const query = graphql.createQuery<RemoveEventAdminMutation, RemoveEventAdminMutationVars>(removeEventAdminMutation)
    return query({ data: { event: eventSlug, id: userId } })
}

const createImageMutation = gql`
    mutation createImage ($data: CreateImage!) {
        createImage(data: $data) {
            id
            file
        }
    }
`
export const createImage = (data: CreateImage) => {
    const query = graphql.createQuery<CreateImageMutation, CreateImageMutationVars>(createImageMutation)
    return query({ data })
}

const deleteImageMutation = gql`
    mutation deleteImage ($id: ID!) {
        deleteImage(id: $id)
    }
`
export const deleteImage = (id: string) => {
    const query = graphql.createQuery<DeleteImageMutation, DeleteImageMutationVars>(deleteImageMutation)
    return query({ id })
}
